export default [
    {tag: 'scratch', intlLabel: 'Scratch'},
    {tag: 'tw', intlLabel: 'TurboWarp'},
    {tag: 'mistium', intlLabel: 'Mistium'},
    {tag: 'momentum', intlLabel: 'Momentum'},
    {tag: 'nitrobolt', intlLabel: 'NitroBolt'}
];
